import React, { useContext, useState } from 'react';
import { Badge, Button, Col, Row } from 'react-bootstrap';
import { SandBoxContext } from './SandboxModal';
import Card from 'react-bootstrap/Card';
import SandBoxRequestDefinitionClient from './RequestDefinitionClient/SandBoxRequestDefinitionClient';
import acApi from '../../axios/ac/acApi';
import { SandboxApiResponse } from './SandBox.types';
import { showToastNotification } from '../../store/ui/toasts/toastsActions';
import { ToastType } from '../../store/ui/toasts/toastsTypes';
import { getErrorMessage } from '../../utils/miscUtil';
import { useDispatch } from 'react-redux';
import BlurredLoader from '../overlays/BlurredLoader';
import SandboxResponse from './SandboxResponse/SandboxResponse';
import BzmIcon from '../icons/BzmIcon';
import clsx from 'clsx';

const SandBox = () => {
  const { state, setState } = useContext(SandBoxContext);
  const [isTesting, setIsTesting] = useState(false);

  const dispatch = useDispatch();

  const onTestRequest = async () => {
    let response: SandboxApiResponse;
    try {
      setIsTesting(true);
      const { id, dsl, httpRequest } = state.sandboxTransaction;
      response = (await acApi.sandbox.testRequest(id, dsl, httpRequest)).data.result as SandboxApiResponse;
    } catch (e) {
      const msg = getErrorMessage(e);
      dispatch(showToastNotification(ToastType.Danger, 'Error testing request', msg));
    } finally {
      setIsTesting(false);
    }

    // Update the state or perform actions as needed
    setState(prevState => ({
      ...prevState,
      response: response,
    }));
  };

  const getStatusPill = (statusCode: number) => {
    return (
      <Badge className={'rounded-pill badge-pill font-weight-semi-bold'} variant={'secondary'}>
        {statusCode}
      </Badge>
    );
  };

  const getResponseStatus = () => {
    const { response } = state;
    let matchPill = null;
    let statusPill = null;

    const roundPillClass = 'rounded-pill badge-pill font-weight-semi-bold';
    if (!response) {
      matchPill = (
        <Badge className={clsx(roundPillClass, 'px-3')} variant="secondary">
          Not Tested Yet
        </Badge>
      );
    } else {
      const isSuccess = response.status !== undefined && response.status !== 404;
      matchPill = (
        <Badge className={clsx(roundPillClass, 'pl-3 pr-4')} variant={isSuccess ? 'success' : 'warning'}>
          <BzmIcon className={'mr-2'} size={14} variant={isSuccess ? 'icon-bzm-checkmark' : 'icon-bzm-caution'} />
          <span style={{ position: 'relative', bottom: '1px' }}>{isSuccess ? 'Matched' : 'No Match'}</span>
        </Badge>
      );

      statusPill = (
        <div className={'d-inline-block'}>
          <span className={'mr-2 ml-4'}>Response Status Code:</span> {getStatusPill(response.status)}
        </div>
      );
    }

    return (
      <div className={'align-middle'}>
        <div className={'d-inline-block'}>
          <span className={'mr-3'}>Response:</span>
          {matchPill}
        </div>
        {statusPill}
      </div>
    );
  };

  return (
    <div className={'p-4'}>
      {/* Header */}
      <Card>
        <Card.Body className={'d-flex align-items-center justify-content-between'}>
          <Button disabled={isTesting || !!state.isAutofilling} onClick={onTestRequest}>
            Test Request
          </Button>
          <div>{getResponseStatus()}</div>
        </Card.Body>
      </Card>
      {/* ./Header */}

      <Row>
        <Col md={6}>
          <Card className={'mb-0'} style={{ minHeight: '55vh' }}>
            <Card.Body>
              <SandBoxRequestDefinitionClient />
            </Card.Body>
          </Card>
        </Col>
        <Col md={6}>
          <Card className={'mb-0'} style={{ minHeight: '55vh' }}>
            <Card.Body>
              <BlurredLoader isLoading={isTesting} loadingText={'Testing Request...'}>
                <SandboxResponse />
              </BlurredLoader>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </div>
  );
};

export default SandBox;
